module.exports = __webpack_public_path__ + "static/13-853d927fd3fa31a96063d9e2848c7a47.jpg";